import gsap from "gsap";

const container = document.querySelector(".indy-block-languagemap-inner");
const elements = document.querySelectorAll(".element");

if (container) {
  let elementSize = calculateElementSize(); // Initiale Berechnung der Elementgröße
  let padding = elementSize * 0.2; // Anfangs-Padding basierend auf elementSize
  
  // Container-Abmessungen ermitteln
  const containerWidth = container.offsetWidth;
  const containerHeight = container.offsetHeight;
  
  // Berechne die Elementgröße basierend auf der Bildschirmbreite
  function calculateElementSize() {
    return window.innerWidth * 0.14; // Beispiel: 5vw entspricht 5% der Bildschirmbreite
  }
  
  // Zufällige Position generieren
  function getRandomPosition() {
    return {
      x: Math.floor(Math.random() * (containerWidth - elementSize)),
      y: Math.floor(Math.random() * (containerHeight - elementSize))
    };
  }
  
  // Überprüfen, ob eine Position sich mit anderen Elementen überschneidet
  function isOverlapping(pos, positions) {
    for (const otherPos of positions) {
      const dx = otherPos.x - pos.x;
      const dy = otherPos.y - pos.y;
      const distance = Math.sqrt(dx * dx + dy * dy);
      if (distance < elementSize + padding) {
        return true;
      }
    }
    return false;
  }
  
  // Funktion, die die Elemente zufällig und ohne Überlappung neu positioniert
  function positionElements() {
    const positions = []; // Leeres Array für Positionen
  
    elements.forEach((element) => {
      let position;
      let tries = 0;
  
      do {
        position = getRandomPosition();
        tries++;
      } while (isOverlapping(position, positions) && tries < 100);
  
      positions.push(position);
  
      // GSAP-Animation zur zufälligen Position
      gsap.set(element, {
        x: position.x,
        y: position.y,
        width: elementSize,
        height: elementSize
      });
    });
  }
  
  // Initiale Positionierung der Elemente
  positionElements();
  
  // Event-Listener für Fenstergrößenänderung
  window.addEventListener("resize", () => {
    // Elementgröße und Padding neu berechnen
    elementSize = calculateElementSize();
    padding = elementSize * 0.2;
  
    // Elemente neu positionieren
    positionElements();
  });
}
